import React, { useContext, useState } from 'react';
import Icon from '../AppIcon';
import Button from './Button';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { DataContext } from 'context/DataContext';
import { PersonStanding } from 'lucide-react';
import { Link } from 'react-router-dom';

const Header = ({ setIsMobileOpen, isMobileOpen }) => {
  const [isNotificationOpen, setIsNotificationOpen] = useState(false);
  const [isAccountOpen, setIsAccountOpen] = useState(false);
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const navigate = useNavigate()
  const { profileData } = useContext(DataContext)
  console.log(profileData?.Profile);


  const notifications = [
    { id: 1, type: 'success', message: 'Bot "Gold Rush" executed profitable trade', time: '2 min ago', unread: true },
    { id: 2, type: 'warning', message: 'High volatility detected in BTC/USDT', time: '5 min ago', unread: true },
    { id: 3, type: 'info', message: 'Weekly performance report available', time: '1 hour ago', unread: false },
    { id: 4, type: 'error', message: 'Connection lost to Binance API', time: '2 hours ago', unread: false },
  ];

  const unreadCount = notifications?.filter(n => n?.unread)?.length;

  const handleSearch = (e) => {
    e?.preventDefault();
    if (searchQuery?.trim()) {
      console.log('Searching for:', searchQuery);
      setIsSearchOpen(false);
      setSearchQuery('');
    }
  };

  const handleNotificationClick = (notification) => {
    setIsNotificationOpen(false);
  };

  const handleAccountAction = (action) => {

    if(action === 'logout'){
      localStorage.clear();
      toast.success("Logged out successfully!")
      navigate('/')
      setIsAccountOpen(false);
    }else if(action === 'profile'){
      navigate('/dashboard/profile')
      setIsAccountOpen(false);

    }

  };

  return (
    <header className="fixed top-0 right-0 left-0 lg:left-72 h-16 bg-background border-b border-border z-40">
      <div className="flex items-center justify-between h-full px-6">

        <div className="flex items-center">
          <Button variant="ghost" onClick={() => setIsMobileOpen(true)} className="lg:hidden mr-2">
            <Icon name="Menu" size={24} />
          </Button>

          {/* <img src={Logo} alt="Logo" className="h-8" /> */}
        </div>

        {/* Right Actions */}
        <div className="flex items-center space-x-2">
          {/* Notifications + Account (your existing code) */}
        </div>

        {/* Right Actions */}
        <div className='flex justify-end w-full'>
          <div className="flex j items-end space-x-2">
            {/* Notifications */}
            <div className="relative">
              {/* <Button
                variant="ghost"
                size="icon"
                onClick={() => setIsNotificationOpen(!isNotificationOpen)}
                className="relative"
              >
                <Icon name="Bell" size={20} />
                {unreadCount > 0 && (
                  <span className="absolute -top-1 -right-1 h-5 w-5 bg-primary text-primary-foreground text-xs font-medium rounded-full flex items-center justify-center">
                    {unreadCount}
                  </span>
                )}
              </Button> */}

              {isNotificationOpen && (
                <div className="absolute right-0 top-12 w-80 bg-popover border border-border rounded-lg trading-shadow z-50">
                  <div className="p-4 border-b border-border-secondary">
                    <div className="flex items-center justify-between">
                      <h3 className="font-semibold text-foreground">Notifications</h3>
                      <Button variant="ghost" size="sm" className="text-xs">
                        Mark all read
                      </Button>
                    </div>
                  </div>
                  <div className="max-h-96 overflow-y-auto">
                    {notifications?.map((notification) => (
                      <div
                        key={notification?.id}
                        onClick={() => handleNotificationClick(notification)}
                        className={`p-4 border-b border-border-secondary cursor-pointer  trading-transition ${notification?.unread ? 'bg-muted/50' : ''
                          }`}
                      >
                        <div className="flex items-start space-x-3">
                          <div className={`w-2 h-2 rounded-full mt-2 ${notification?.type === 'success' ? 'bg-success' :
                              notification?.type === 'warning' ? 'bg-warning' :
                                notification?.type === 'error' ? 'bg-error' : 'bg-primary'
                            }`} />
                          <div className="flex-1 min-w-0">
                            <p className="text-sm text-foreground">{notification?.message}</p>
                            <p className="text-xs text-muted-foreground mt-1">{notification?.time}</p>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                  <div className="p-4 border-t border-border-secondary">
                    <Button variant="ghost" size="sm" className="w-full">
                      View all notifications
                    </Button>
                  </div>
                </div>
              )}
            </div>

            {/* Account Dropdown */}
            <div className="relative">
              <Button
                variant="ghost"
                onClick={() => setIsAccountOpen(!isAccountOpen)}
                className="flex items-center space-x-2 px-3"
              >
                <div className="w-8 h-8 bg-primary rounded-full flex items-center justify-center">
                  <span className="text-sm font-semibold text-primary-foreground">
                    {profileData?.Profile?.Email?.charAt(0)?.toUpperCase()}
                  </span>
                </div>

                <Icon name="ChevronDown" size={16} />
              </Button>

              {isAccountOpen && (
                <div className="absolute right-0 top-12 w-64 bg-popover border border-border rounded-lg trading-shadow z-50">
                  <div className="p-4 border-b border-border-secondary">
                    <div className="flex items-center space-x-3">
                      <div className="w-10 h-10 bg-primary rounded-full flex items-center justify-center">
                        <span className="text-sm font-semibold text-primary-foreground"> {profileData?.Profile?.Email?.charAt(0)?.toUpperCase()}</span>
                      </div>
                      <Link to="/dashboard/profile" className="flex flex-col" onClick={() => setIsAccountOpen(false)}>
                        <p>My Profile</p>
                        {/* <p className="font-medium text-foreground">{profileData?.Profile?.Name}</p>
                        <p className="text-sm text-muted-foreground">{profileData?.Profile?.Sponsor}</p> */}
                      </Link>
                    </div>
                  </div>
                  <div className="">
                    {/* <Button
                      variant="ghost"
                      onClick={() => handleAccountAction('profile')}
                      className="w-full justify-start"
                    >
                      <Icon name="User" size={16} className="mr-3" />
                      Profile Settings
                    </Button> */}
                    {/* <Button
                      variant="ghost"
                      onClick={() => handleAccountAction('billing')}
                      className="w-full justify-start"
                    >
                      <Icon name="CreditCard" size={16} className="mr-3" />
                      Billing & Plans
                    </Button>
                    <Button
                      variant="ghost"
                      onClick={() => handleAccountAction('exchanges')}
                      className="w-full justify-start"
                    >
                      <Icon name="Link" size={16} className="mr-3" />
                      Exchange Connections
                      <div className="ml-auto flex space-x-1">
                        <div className="w-2 h-2 bg-success rounded-full" />
                        <div className="w-2 h-2 bg-success rounded-full" />
                        <div className="w-2 h-2 bg-error rounded-full" />
                      </div>
                    </Button>
                    <Button
                      variant="ghost"
                      onClick={() => handleAccountAction('help')}
                      className="w-full justify-start"
                    >
                      <Icon name="HelpCircle" size={16} className="mr-3" />
                      Help Center
                    </Button> */}
                  </div>
                  <div className="p-2 border-t border-border-secondary">
                    <Button
                      variant="ghost"
                      onClick={() => handleAccountAction('logout')}
                      className="w-full justify-start text-error "
                    >
                      <Icon name="LogOut" size={16} className="mr-3" />
                      Sign Out
                    </Button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      {/* Click outside handlers */}
      {(isNotificationOpen || isAccountOpen) && (
        <div
          className="fixed inset-0 z-30"
          onClick={() => {
            setIsNotificationOpen(false);
            setIsAccountOpen(false);
          }}
        />
      )}
    </header>
  );
};

export default Header;